import { ApplicationType } from "./constants/app";
import { Level0, TLink, TShopMenu } from "../entities/content";
import { isShopAvailableAndLogoLinksToShop } from "./helper/shop-helper";
import { GlobalDataLayerService } from "../services/analytics/global-data-layer-service";
import { ClickElementTypes, EventActions } from "./constants";

export function getLogoLink(
  locale: string,
  app: ApplicationType,
  crest: TLink | null,
  shop: TShopMenu | null,
): string | undefined {
  const link =
    shop && isShopAvailableAndLogoLinksToShop(locale, app, shop)
      ? shop.link
      : crest?.link;

  return link;
}

export function getLogoAriaLabel(
  locale: string,
  app: ApplicationType,
  shop: TShopMenu | null,
  level0: Level0,
): string {
  return isShopAvailableAndLogoLinksToShop(locale, app, shop)
    ? level0?.["mainmenu.level0.shop.porschelogo"]
    : level0?.["mainmenu.level0.porschelogo"];
}
export function sendLogoDataLayerEvent(crest: TLink | null): void {
  GlobalDataLayerService.getInstance().pushDataLayerEvent(
    EventActions.CREST_CLICK,
    {
      componentClick: {
        clickElementId: crest?.id,
        clickElementName: crest?.text,
        clickElementType: ClickElementTypes.Link,
        targetUrl: crest?.link,
      },
    },
  );
}
